import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
import AuthRouter from './components/AuthRouter';
import { ToastElement, ToastContainer } from './components/Toast';
import './assets/tailwind.css';

const App: React.FC<unknown> = () => {
    return (
        <ToastProvider components={{ Toast: ToastElement, ToastContainer }}>
            <Router>
                <AuthRouter />
            </Router>
        </ToastProvider>
    );
};

export default App;
